// extracted by mini-css-extract-plugin
export var button = "_9-0";
export var buttonContent = "_9-e";
export var buttonGroup = "_9-c";
export var dontRestrainIconWidth = "_9-a";
export var dropdownButton = "_9-b";
export var iconContainer = "_9-9";
export var lg = "_9-4";
export var md = "_9-3";
export var pending = "_9-f";
export var sm = "_9-2";
export var spinner = "_9-d";
export var squared = "_9-8";
export var wrapText = "_9-g";
export var xl = "_9-5";
export var xs = "_9-1";
export var xxl = "_9-6";
export var xxxl = "_9-7";